import { render, staticRenderFns } from "./TicketboardRowActions.vue?vue&type=template&id=0ab44c40&"
import script from "./TicketboardRowActions.vue?vue&type=script&lang=js&"
export * from "./TicketboardRowActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports